import { render, staticRenderFns } from "./vehicle-license.vue?vue&type=template&id=db511f00&"
import script from "./vehicle-license.vue?vue&type=script&lang=js&"
export * from "./vehicle-license.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports